export default "__VITE_ASSET__d651dd7e__"